import { FC, useState } from 'react'
import { DraftReview } from './types/types'
import { getDateTimeString } from 'lib/helpers/dateHelper'
import ReviewsModal from './ReviewsModal'
import styles from './ReviewsSection.module.scss'

interface ReviewsSectionProps {
  draftId: number
  recentReviews: DraftReview[]
}

const ReviewsSection: FC<ReviewsSectionProps> = ({ draftId, recentReviews }) => {
  const [showAllReviews, setShowAllReviews] = useState(false)

  if (!recentReviews || recentReviews.length === 0) {
    return null
  }

  // Show only the last 2 reviews
  const displayedReviews = recentReviews.slice(0, 2)
  const hasMoreReviews = recentReviews.length > 2

  return (
    <>
      <div className={styles.reviewsSection}>
        <div className={styles.reviewsHeader}>
          <h4>Curation Comments</h4>
          {hasMoreReviews && (
            <button className={styles.viewAllButton} onClick={() => setShowAllReviews(true)}>
              View All ({recentReviews.length}+)
            </button>
          )}
        </div>
        <div className={styles.reviewsList}>
          {displayedReviews.map((review) => (
            <div key={review.id} className={styles.reviewItem}>
              <div className={styles.reviewHeader}>
                <span className={styles.reviewerName}>{review.reviewedBy}</span>
                <span className={styles.reviewDate}>{getDateTimeString(new Date(review.reviewedAt))}</span>
              </div>
              <p className={styles.reviewComment}>{review.comment}</p>
            </div>
          ))}
        </div>
      </div>
      {showAllReviews && <ReviewsModal draftId={draftId} onClose={() => setShowAllReviews(false)} />}
    </>
  )
}

export default ReviewsSection
